module.exports = __webpack_public_path__ + "media/images/icons/flags/MK-eb8e0f08973989cb8b60d416bca5eb97.svg";